import { Theme } from '@mui/material';

export default {
	styleOverrides: {
		root: ({ theme }: { theme: Theme }) => ({
			display: 'flex',
			alignItems: 'center',
			padding: '8px 16px 8px 8px',
			borderRadius: '9999px',
			color: theme.palette.text.secondary,
		}),
	},
};
